// src/pages/AccountPage.js
import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom'; // Import Navigate for redirect
import AuthForm from '../components/AuthForm';
import AccountDetails from '../components/AccountDetails';
import { AuthContext } from '../context/AuthContext';
import PhoneAuth from './phoneAuth';

const AccountPage = () => {
  const { currentUser, loading } = useContext(AuthContext);

  useEffect(() => {
    if (currentUser) {
      localStorage.setItem("userdetails", JSON.stringify(currentUser.phone || null));
    }
  }, [currentUser]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {currentUser ? (
        <AccountDetails />
      ) : (
        <Navigate to="/login" replace />
        // or show PhoneAuth instead:
        // <PhoneAuth />
      )}
    </>
  );
};

export default AccountPage;
